import { Instagram, Music2 } from "lucide-react";
import { CONFIG } from "../../lib/config";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#09090b] px-5 py-14 lg:px-10">
      <div className="mx-auto flex max-w-[1600px] flex-col items-start justify-between gap-10 lg:flex-row lg:items-end">
        <div>
          <span className="font-display text-4xl leading-none tracking-tight text-[#FF0000]">
            AKTRA
          </span>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-500">
            Collectif fondé par {CONFIG.founder.name} ({CONFIG.founder.alias}). Éclipse — la nuit où
            l’été s’éteint.
          </p>
          <a
            href={CONFIG.venueUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-venue"
            className="mt-4 inline-block font-mono-x text-[10px] uppercase tracking-[0.25em] text-zinc-400 link-underline"
          >
            @ Flow · Paris ↗
          </a>
        </div>

        <div className="flex flex-col gap-4">
          <span className="font-mono-x text-[10px] uppercase tracking-[0.3em] text-zinc-600">
            Suivre Nokuji
          </span>
          <div className="flex gap-3">
            <a
              href={CONFIG.nokuji.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-tiktok"
              className="flex h-11 w-11 items-center justify-center border border-white/15 text-white transition-colors duration-300 hover:border-[#FF0000] hover:text-[#FF0000]"
            >
              <Music2 className="h-4 w-4" />
            </a>
            <a
              href={CONFIG.nokuji.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="flex h-11 w-11 items-center justify-center border border-white/15 text-white transition-colors duration-300 hover:border-[#FF0000] hover:text-[#FF0000]"
            >
              <Instagram className="h-4 w-4" />
            </a>
          </div>
          <a
            href={CONFIG.lemfiUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-lemfi"
            className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-zinc-500 link-underline"
          >
            Powered by LemFi
          </a>
        </div>
      </div>

      <div className="mx-auto mt-12 flex max-w-[1600px] flex-col items-start justify-between gap-2 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
        <span className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-zinc-600">
          © {new Date().getFullYear()} AKTRA — Tous droits réservés
        </span>
        <span className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-zinc-600">
          {CONFIG.eventName} · {CONFIG.location}
        </span>
      </div>
    </footer>
  );
}
